<template>
  <div class="foral-design">
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top">
      <div class="grid">
        <div class="grid-left fade-in-left">
          <h1 class="page-title" data-FadeInLeft-stagger>
            Floral Design
          </h1>
          <p data-FadeInLeft-stagger>
            Unique creations for every occasion using fresh locally grown
            flowers are how we ensure our floral arrangements stand out.
            We are constantly learning and developing our techniques so
            that we are on top of the latest trends. We take pride in our
            creative designs and strive to create each persons individual
            visions into an awe-inspiring settings for occasions that end
            up as treasured memories.
          </p>
          <router-link :to="{name: 'GetInTouch'}"
                       class="btn btn-primary grid-left__button"
                       title="Get In Touch">
            Get In Touch
          </router-link>
        </div>
        <div class="grid-right fade-in-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import fadeInLeftStagger from '@/mixins/staggerFadeInLeft'

export default {
  name: 'FloralDesign',
  mixins: [fadeInLeftStagger],
  metaInfo: {
    title: 'Berries and Blooms - Floral Design',
    links: [
      { rel: 'canonical', href: 'http://berriesandblooms.co.za/floral-design' },
      { rel: 'alternate', href: 'http://berriesandblooms.co.za/floral-design', hreflang: 'en-us' },
    ],
  },
}
</script>

<style lang="scss" scoped>
  .grid {
    background: rgba(255, 255, 255, .65);
    display: grid;
    padding: 40px 20px;

    @media(min-width: 992px) {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .10);
      grid-template-columns: 1fr 1fr;
      grid-template-areas: 'grid-left grid-right';
      padding: 0;
    }

    @media(min-width: 1336px) {
      margin: 20px 160px 0;
    }
  }

  .grid-left {
    grid-area: grid-left;

    @media(min-width: 992px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 55px;
    }

    @media(min-width: 1200px) {
      padding: 50px 80px 80px;
    }

    .grid-left__button {
      background-color: $brand-primary;
      border-color: transparent;
      display: inline-block;
      padding: 10px 0;
      width: 130px;
    }
  }

  .grid-right {
    @media(min-width: 992px) {
      background-image: url('~@/assets/gallery_image_33.jpg');
      grid-area: grid-right;
      height: 60vh;
      background-size: cover;
      background-repeat: no-repeat;
    }

    @media(min-width: 1280px) {
      height: 100%;
    }

    @media(min-width: 1336px) {
      height: 85vh;
    }
  }

  .foral-design {
    .page-title {
      font-family: 'great_vibesregular';
      font-size: 3.5rem;
      font-weight: 700;
      margin: 2rem 0;
      padding-bottom: 10px;
      position: relative;

      &::before {
        background: rgba($brand-primary, 1);
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 55px;
      }
    }

    p {
      font-size: 1rem;
      font-weight: 300;
      line-height: 1.8;
      margin: 10px 0 40px;

      @media(min-width: 1200px) {
        font-size: 1.2rem;
      }
    }
  }
</style>
